var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abk-offer-form',{attrs:{"submit-action":_vm.createOffer,"validate-action":_vm.validate}})}
var staticRenderFns = []

export { render, staticRenderFns }